import { z } from "zod";
import {
  SourceImageCustomInput,
  SourceImageProviderType,
} from "./source-image.ts";

export const SourceImagePresetDto = z.object({
  externalId: z.string(),
  name: z.string(),
  provider: SourceImageProviderType,
  customInput: SourceImageCustomInput,
  tags: z.array(z.string()),
  teamExternalId: z.string().nullable(),
  generatedSrc: z.string().nullable(),
  originalSrc: z.string().nullable(),
  sourceImageExternalId: z.string(),
  isFavourite: z.boolean(),
});

export const SetSourceImagePresetFavouriteDto = z.object({
  isFavourite: z.boolean(),
});

export const UpdateSourceImagePresetDto = z.object({
  name: z.string(),
  provider: SourceImageProviderType,
  customInput: SourceImageCustomInput,
  tags: z.array(z.string()),
});

export const DeleteSourceImagePresetResponseDto = z.object({
  success: z.boolean(),
});

export const PagedSourceImagePresetsRequestDto = z.object({
  pageSize: z.number().nullable(),
  cursorCreatedAt: z.string().optional(),
  cursorExternalId: z.string().optional(),
  isFavourite: z.boolean().optional(),
});

export const PagedSourceImagePresetsResponseDto = z.object({
  presets: z.array(SourceImagePresetDto),
  nextCursor: z
    .object({
      createdAt: z.string(),
      externalId: z.string(),
    })
    .nullable(),
});

export type SourceImagePresetDto = z.infer<typeof SourceImagePresetDto>;
export type UpdateSourceImagePresetDto = z.infer<
  typeof UpdateSourceImagePresetDto
>;
export type SetSourceImagePresetFavouriteDto = z.infer<
  typeof SetSourceImagePresetFavouriteDto
>;
export type DeleteSourceImagePresetResponseDto = z.infer<
  typeof DeleteSourceImagePresetResponseDto
>;
export type PagedSourceImagePresetsRequestDto = z.infer<
  typeof PagedSourceImagePresetsRequestDto
>;
export type PagedSourceImagePresetsResponseDto = z.infer<
  typeof PagedSourceImagePresetsResponseDto
>;
